import { useContext } from 'react'
import { RoleContext } from '@BUP/contexts/RoleContext'
import { FINANCE } from '@BUP/constants'

/**
 * True when the active role is FINANCE, which must see My School in
 * read-only mode: every mutation control is hidden (not disabled).
 * Returns false for any other role and while the role is still loading
 * (null), so existing behavior is preserved by default.
 */
export const useIsFinanceReadOnly = () => {
  const role = useContext(RoleContext)
  return role?.type === FINANCE
}
